$('.js-footer').each((index, element) => {
	let $component = $(element);
	let $infoBtn = $component.find('.js-info-btn');
	let $infoContent = $component.find('.js-info-content');
	let infoTimeout;

	$infoBtn.on('mouseenter', () => {
		$infoContent.stop(true, true).addClass('active');

		if (infoTimeout) {
			clearTimeout(infoTimeout);
		}
	});

	$infoBtn.on('mouseleave', () => {
		infoTimeout = setTimeout(() => {
			$infoContent.stop(true, true).removeClass('active');
		}, 400);
	});

	$infoContent.on('mouseenter', () => {
		if (infoTimeout) {
			clearTimeout(infoTimeout);
		}
	});

	$infoContent.on('mouseleave', () => {
		infoTimeout = setTimeout(() => {
			$infoContent.stop(true, true).removeClass('active');
		}, 400);
	});

	$component.on('footer:show', () => {
		$component.addClass('active');
	});
});
